// extracted by mini-css-extract-plugin
export default {"newterm":"NewTermForm_newterm__paE6a","newtermTop":"NewTermForm_newtermTop__fMu2v","quillContainer":"NewTermForm_quillContainer__mb6Rp"};